import { MemberTypeEnum } from '~/enums';
import { AddOrgMembersForm } from '~/pages/Authenticated/AddOrgMember/components/Form';

import { useAddChildOrgController } from './controller';

export const AddChildOrg = () => {
  const {
    handleCreatePublicInvite,
    handleInvitePartner,
    isSubmittingPublicInvite,
    isSubmitting,
  } = useAddChildOrgController();

  return (
    <AddOrgMembersForm
      isSubmitting={isSubmitting}
      onSubmitInviteMember={handleInvitePartner}
      memberType={MemberTypeEnum.ChildOrg}
      title="Add Child Organization"
      isSubmittingPublicInvite={isSubmittingPublicInvite}
      onSubmitPublicInviteMember={handleCreatePublicInvite}
    />
  );
};

export default AddChildOrg;
